/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Box, Checkbox, Container, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material';
import styled from 'styled-components';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';
import { cpf as CpfValidator } from 'cpf-cnpj-validator';
import Swal from 'sweetalert2';
import scrollToElement from 'scroll-to-element';

import { useAuth } from '../../providers/AuthProvider';
import ApiService from '../../helpers/ApiService';
import { CTA } from '../Common/CTA';

// import CustomCheckbox from './CustomCheckbox';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useCookies } from '../../providers/CookiesProvider';
import { useDrawer } from '../../providers/DrawerProvider';

const FormRegisterContainer = styled.div`
  form {
    .MuiInputBase-root {
      color: var(--bluegray-400);
      background-color: var(--white);
    }
    .MuiFormHelperText-root {
      color: var(--bluegray-400);
    }
    .MuiFormControlLabel-label  {
      color: var(--white);
    }

    hr {
      border: none;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      margin: 1rem 5rem;
    }
  }
`;

export const FormRegister = () => {
  const { login } = useAuth();
  const { setFormPanel, setOpenDrawer } = useDrawer();
  const { cookiesAllowed, setCookiesAllowed } = useCookies();
  const { register, handleSubmit, formState: {errors}, control, setError, clearErrors, setValue, getValues } = useForm();
  const [terms, setTerms] = React.useState(false);
  const [isLoading, setisLoading] = React.useState(false);

  useEffect(() => {
    let mounted = true;
    if(mounted) {
      register('name');
      register('email');
      register('cpf');
      register('cellphone');
      register('password');
      register('confirmPass');
      register('acceptTerms');
    }
  
    return () => mounted = false;
  }, []);

  const thisCPFisValid = async ( cpf ) => {
    return CpfValidator.isValid(String(cpf).replace(/\D/g, ''));
  }

  const validateCpf = async ( cpf ) => {
    setValue('cpf', cpf);
    if (!(await thisCPFisValid(cpf))) {
      setError('cpf', { type: 'manual', message: 'CPF inválido!' });
    }
    else {
      clearErrors('cpf');
    }
  }

  const checkTermsHandler = () => {
    setTerms(!terms);
    setValue('acceptTerms', !terms);
  }

  const checkConfirmPassword = (e) => {
    if (e.target.value !== getValues("password") ) {
      setError("confirmPass")
    }
    else {
      clearErrors("confirmPass");
    }
  }

  const goToRules = () => {
    setOpenDrawer(false);
    setTimeout(() => {
      scrollToElement(`#rules`, {
        duration: 500,
        offset: 2
      });
    }, 500);
  }

  const onSave = async data => {
    setisLoading(true);
    if ( !( await thisCPFisValid(data.cpf) ) ) {
      validateCpf(data.cpf);
      Swal.fire({
        icon: 'error',
        title: 'CPF incorreto',
        text: 'O CPF digitado parece não estar correto. Por favor, verifique e tente novamente.',
        confirmButtonText: "Verificar agora",
      }).then( () => {
        document.getElementById('cpf')?.focus();
      });
      setisLoading(false);
      return;
    }
    if(data.password !== data.confirmPass) {
      setError("confirmPass")
      Swal.fire({
        icon: 'error',
        title: 'Senha incorreta',
        text: 'A confirmação de senha está incorreta. Por favor, preencha corretamente os campos.',
        confirmButtonText: "Corrigir",
      }).then( () => {
        document.getElementById('confirmPass')?.focus();
      });
      setisLoading(false);
      return;
    }
    if(!cookiesAllowed) {
      Swal.fire({
        icon: 'info',
        title: 'Uso de Cookies',
        text: 'Para prosseguir, é necessário que você concorde com a utilização de cookies para sua melhor experiência.',
        confirmButtonText: "Concordar e continuar",
        focusConfirm: true,
      }).then(result => {
        if(result.isConfirmed) {
          localStorage.setItem(process.env.REACT_APP_ACCEPT_COOKIES, true);
          setCookiesAllowed(true);
          submitUser(data);
        }
        setisLoading(false);
      });
      return;
    }
    submitUser(data);
  }

  const submitUser = async (data) => {
    delete data.confirmPass;

    ApiService.post('user/create', data).then( (result) => {
      let status = result.status;
      let token = result.data.token;

      if( status === 200 ) {
        setisLoading(false);
        setOpenDrawer(false);
        login(token);
      }
    }).catch( (error) => {
      if ( error.status === 400 ) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Usuário já está cadastrado. Faça seu login.',
          confirmButtonText: "Entendi"
        });
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.',
          confirmButtonText: "Entendi"
        });
      }
      setisLoading(false);
    });
  }
  
  return (
    <FormRegisterContainer>
      <Container>
        <form onSubmit={handleSubmit(onSave)}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12} align="center">
              <Box mt={4} mb={2}>
                <Typography variant="body1" className="middle--text">
                  Preencha os campos com seus dados
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name='name'
                control={control}
                defaultValue=""
                render={ ({ field: {onChange, value}, fieldState: { error }}) => (
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Nome completo"
                    placeholder="Nome completo"
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={errors.name && "Nome obrigatório"}
                  />
                )}
                rules={{ required: 'Nome obrigatório' }}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name="email"
                control={control}
                defaultValue=""
                render={ ({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextField
                    id='emailRegister'
                    type="email"
                    label="E-mail"
                    placeholder="E-mail"
                    variant="outlined"
                    fullWidth
                    value={value}
                    onChange={(e) => onChange(String(e.target.value).toLowerCase())}
                    error={!!error}
                    helperText={error ? "E-mail inválido" : null}
                    // {...register('email', { required: true, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ })}
                  />
                )}
                rules={{ required: 'E-mail obrigatório', pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ }}
                register
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Controller
                control={control}
                name="cpf"
                rules={{ required: true, pattern: /^[0-9][0-9][0-9]\.[0-9][0-9][0-9]\.[0-9][0-9][0-9]-[0-9][0-9]$/i }}
                render={({ onChange, onBlur, value }) => (
                  <InputMask
                    mask="999.999.999-99"
                    disabled={false}
                    maskChar=" "
                    name="cpf"
                    onBlur={onBlur}
                    onChange={(e) => {
                      validateCpf(e.target.value);
                    }}
                    value={value}
                  >
                    {() => (
                      <TextField
                        id="cpf"
                        type="tel"
                        error={!!errors.cpf}
                        helperText={errors.cpf && (errors.cpf.message || 'Preencha corretamente')}
                        variant="outlined"
                        label="CPF"
                        placeholder="CPF"
                        name="cpf"
                        fullWidth
                      />
                    )}
                  </InputMask>
                )}
                defaultValue=""
                />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Controller
                name="cellphone"
                control={control}
                rules={{ required: 'Telefone obrigatório', pattern: /^\([0-9]+\) [0-9]+-[0-9]+$/i }}
                render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
                  <InputMask
                    mask="(99) 99999-9999"
                    maskChar=" "
                    onChange={onChange}
                    value={value}
                  >
                    { () => (
                      <div>
                        <TextField
                          label="Telefone"
                          placeholder="Telefone"
                          variant="outlined"
                          fullWidth
                          type="tel"
                          onChange={onChange}
                          error={!!error}
                          helperText={error ? "Telefone inválido" : null}
                          inputRef={ref}
                        />
                      </div>
                    )}
                  </InputMask>
                )}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
            <Controller
                name='password'
                control={control}
                defaultValue=""
                render={ ({ field: {onChange, value}, fieldState: { error }}) => (
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="Senha"
                    placeholder="Senha"
                    type="password"
                    onChange={onChange}
                    value={value}
                    error={!!error}
                    helperText={errors.password && "Senha deve conter pelo menos 6 caracteres"}
                  />
                )}
                rules={{ required: 'A senha deve ter no mínimo 6 caracteres', minLength: 6 }}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Controller
                name='confirmPass'
                control={control}
                defaultValue=""
                render={ ({ field: {onChange, value}, fieldState: { error }}) => (
                  <TextField
                    id='confirmPass'
                    variant="outlined"
                    fullWidth
                    label="Confirmar senha"
                    placeholder="Confirmar senha"
                    type="password"
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      checkConfirmPassword(e);
                    }}
                    error={!!error}
                    helperText={errors.confirmPass && "Senha deve ser igual a senha acima"}
                  />
                )}
                rules={{ required: 'A senha deve ter no mínimo 6 caracteres', minLength: 6 }}
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Box my={1}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="acceptTerms"
                        onChange={checkTermsHandler}
                        rules={{ required: true }}
                        sx={{
                          color: 'var(--bluegray-400)',
                          '&.Mui-checked': {
                            color: 'var(--bluegray-600)',
                          },
                        }}
                      />
                    }
                    label={
                      <div>
                        <Typography variant='body2' component='span' className='dark--text'>Ao clicar nesta opção você aceita nossa
                          <Link to='/politica-de-privacidade' className='bold-text primary--text'> Política de Privacidade </Link>
                          e está de acordo com o <span onClick={goToRules} className='bold-text primary--text'>regulamento</span> da promoção.
                        </Typography>
                      </div>
                    }
                  />
                </FormGroup>
              </Box>
            </Grid>
            <Grid item sm={12} xs={12} align="center" mt={2}>
              <CTA
                disabled={!terms || isLoading}
                type="submit"
              >
                Cadastrar
              </CTA>
            </Grid>
            <Grid item sm={12} xs={12} align="center">
              <hr />
              <Box mb={4}>
                <Typography variant="body1" className="dark--text" gutterBottom>
                  Já possui cadastro? <span className="bold-text button-text" onClick={ () => setFormPanel("login") }>Entre com sua conta.</span>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Container>
    </FormRegisterContainer>
  )
}